exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h2 {\n  color: #9FB0BF;\n  font-weight: bold;\n  font-size: 22px;\n  margin-bottom: 16px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /mnt/d/Projects/angular/chisparural-foro/src/app/signup/password-reset/password-reset.component.scss
// module id = ../../../../../src/app/signup/password-reset/password-reset.component.scss
// module chunks = 1